import { Modal, PencilIcon, PlusIcon } from "djinn-components";
import React, { useState } from "react";
import { useSiteState } from "../../../utils/useSiteState";
import { Link } from "react-router-dom";
import HelpLink from "../../../components/HelpLink";
import CreatePageForm from "../../../components/Forms/CreatePageForm";

interface PagesIndexScreenProps {}

const PagesIndexScreen: React.FC<PagesIndexScreenProps> = () => {
  const { site } = useSiteState();
  const [showAddPage, setShowAddPage] = useState(false);

  return (
    <>
      <title>Edit Pages</title>
      <div className="max-w-5xl mx-auto mt-6 w-full">
        <div className="max-w-5xl mx-auto flex justify-between mt-10 mb-4">
          <div>
            <h2 className="text-2xl leading-6 font-regular text-white">
              Pages
            </h2>
            <p className="text-xs text-gray-400 mt-1">
              Manage your site pages from here
            </p>
          </div>
        </div>
        <div className="w-full">
          <table
            className="table-auto border-separate mr-0 w-full"
            style={{ borderSpacing: "0 1.2rem" }}
          >
            <thead className="opacity-100 bg-opacity-100">
              <tr>
                <td className="bg-gray-800 text-left text-md leading-4 font-large text-white tracking-wider opacity-100 bg-opacity-100 pl-6">
                  Title
                </td>
                <td className="bg-gray-800 text-left text-md leading-4 font-large text-white tracking-wider">
                  Type
                </td>
                <td className="bg-gray-800 text-left text-md leading-4 font-large text-white tracking-wider">
                  Slug
                </td>
                <td className="px-6 bg-gray-800 lg:w-10 w-12" width="5%"></td>
              </tr>
            </thead>
            <tbody className="max-h-124 w-full">
              {site.pages.map((page, index: number) => (
                <tr
                  className={
                    "bg-gray-600 bg-opacity-50 rounded-full mb-6 h-12 pl-6 overflow-hidden w-full"
                  }
                  key={index}
                >
                  <td className="whitespace-no-wrap rounded-l-full text-sm leading-5 font-regular text-white opacity-75 pl-6">
                    {page.title}
                  </td>
                  <td className="whitespace-no-wrap text-sm font-light leading-5 text-white opacity-50 ">
                    {page.template}
                  </td>
                  <td className="whitespace-no-wrap text-sm font-light leading-5 text-white opacity-50 ">
                    {page.slug}
                  </td>
                  <td width="5%" className="rounded-r-full">
                    <Link to={`/${site.id}/pages/${page.id}`}>
                      <PencilIcon
                        size={18}
                        className="hover:text-primary w-5 h-6 text-white block"
                      />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="w-full flex justify-between items-center mt-4">
          <HelpLink
            text="Need help managing pages"
            link="guides/managing-site-pages"
          />
          <button
            type="button"
            className="h-10 mb-1 bg-green-600 hover:bg-green-700 rounded-full px-4 flex justify-center items-center text-white text-xs font-medium focus:outline-none"
            onClick={(e) => {
              e.preventDefault();
              setShowAddPage(true);
            }}
          >
            Add Page <PlusIcon className="ml-3 w-5 h-5" size={18} />
          </button>
        </div>
        <Modal shown={showAddPage} onClose={() => setShowAddPage(false)}>
          <CreatePageForm />
        </Modal>
      </div>
    </>
  );
};

export default PagesIndexScreen;
